export const updates = [
    {
        id: '2023-06-14',
        date: '2023-06-14 12:30 GMT',
        label: 'Update - 14 June 2023',
    },
	{
        id: '2023-01-01',
        date: '2023-01-01 12:30 GMT',
        label: 'Update - 01 January 2023',
    },
    {
        id: '2022-09-08',
        date: '2022-09-08 12:30 GMT',
        label: 'Update - 08 September 2022',
    },
	{
        id: '2022-06-03',
        date: '2022-06-03 22:30 GMT',
        label: 'Update - 03 June 2022',
    },
	{
        id: '2021-12-07',
        date: '2021-12-07 17:30 GMT',
        label: 'Update - 07 December 2021',
    },
	{
        id: '2021-08-26',
        date: '2021-08-26 17:30 GMT',
        label: 'Update - 26 August 2021',
    },
	{
        id: '2021-07-26',
        date: '2021-07-26 17:30 GMT',
        label: 'Update - 26 July 2021',
    },
	{
        id: '2021-06-10',
        date: '2021-06-10 17:30 GMT',
        label: 'Update - 10 June 2021',
    },
    {
        id: '2020-07-18',
        date: '2020-07-18 17:30 GMT',
        label: 'Update - 18 July 2020',
    },
	// {
    //     id: '2020-02-14',
    //     date: '2020-02-214 17:30 GMT',
    //     label: 'Update - 14 February 2020',
    // },
    {
        id: '2019-04-04',
        date: '2019-04-04 12:30 GMT',
        label: 'Update - 4 April 2019',
    },
    {
        id: '2018-11-20',
        date: '2018-11-20 15:30 GMT',
        label: 'Update - 20 November 2018',
    },
    {
        id: '2018-07-19',
        date: '2018-07-19 13:30 GMT',
        label: 'Update - 19 July 2018',
    },
    {
        id: '2018-07-04',
        date: '2018-07-04 12:00 GMT',
        label: 'Update - 4 July 2018',
    },
    {
        id: '2018-05-31',
        date: '2018-05-31 15:00 GMT',
        label: 'Update - 31 May 2018',
    },
    {
        id: '2018-05-23',
        date: '2018-05-23 15:30 GMT',
        label: 'Update - 23 May 2018',
    },
    {
        id: '2018-04-24',
        date: '2018-03-04 14:30 GMT',
        label: 'Update - 24 April 2018',
    },
    {
        id: '2018-04-12',
        date: '2018-04-12 15:00 GMT',
        label: 'Update - 12 April 2018',
    },
    {
        id: '2018-03-04',
        date: '2018-03-04 12:30 GMT',
        label: 'Update - 4 March 2018',
    },
];



// WEBPACK FOOTER //
// ./src/portal/states/company/whats-new/updates.js